// extracted by mini-css-extract-plugin
module.exports = {"component":"content-navigation_component__EaJnN","counter":"content-navigation_counter__Hpbp_","visuallyHidden":"content-navigation_visuallyHidden__9lm6J"};